import { Routes as Switch, Route, useMatch as useRouteMatch } from 'react-router-dom';
import Head from './head';
import { Body } from 'components/reportBody';
import BodyCompiler from 'components/reportBody/newReportCompiler';
function RicostruzioneCodici() {
  const path = '';
  return (
    <Switch>
      <Route exact path={path} element={<Head />} />
      <Route exact path={`${path}/body`} element={<BodyCompiler mainTitle={"Ricostruzione codici statistici"} />} />
      <Route path={`${path}/*`} exact={true} element={<Head />} />
    </Switch>
  );
}

export default RicostruzioneCodici;
